exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px) {\nheader {\n    position: relative;\n    background: #F4F3EF;\n}\n}\nfooter {\n  display: none;\n}\n", ""]);

// exports
